import React from 'react';

const ChevronForward = ({ color = '' }: { color: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.0293 7.50016L12.0291 7.49993L5.09555 0.966933L5.09513 0.966531C4.80182 0.691471 4.32453 0.677525 4.01273 0.930139L4.01273 0.930138L4.01224 0.930538C3.68182 1.19963 3.65861 1.67121 3.97113 1.9658L3.97116 1.96583L10.3746 7.99989L3.97116 14.0339L3.9709 14.0342C3.6593 14.3286 3.68212 14.8008 4.01301 15.0695L4.01328 15.0697C4.16447 15.1921 4.35195 15.2499 4.53311 15.2499C4.7324 15.2499 4.93829 15.1804 5.09518 15.0332L5.09555 15.0328L12.0291 8.49984L12.0293 8.49961C12.3237 8.22146 12.3237 7.77831 12.0293 7.50016Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default ChevronForward;
